import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchDashboardData } from "../../../redux/score-insights/scoreInsightsActions";
import useFormData from "./useFormData";

/**
 * This hook should handle the initial load only. Subsequent loads are triggered by the form.
 */
const useFetchInitialDashboardData = (dashboardId) => {
	const { initialRequestParams } = useFormData();
	const dispatch = useDispatch();
	const { currentDashboard, dashboardData } = useSelector((state) => state.scoreInsightsDashboard);
	const currentDashboardDataId = dashboardData?.dashboardId;

	useEffect(() => {
		// initial fetch only
		if (currentDashboardDataId === dashboardId || currentDashboard?._id !== dashboardId) {
			return;
		}

		const requestParams = {
			...initialRequestParams,
			locations: initialRequestParams.locations?.length
				? initialRequestParams.locations
				: currentDashboard.locations,
			socCodes: initialRequestParams.socCodes?.length
				? initialRequestParams.socCodes
				: currentDashboard.soc_codes,
			soc_occupation_quantities: initialRequestParams.soc_occupation_quantities?.length
				? initialRequestParams.soc_occupation_quantities
				: currentDashboard.soc_occupation_quantities,
		};

		dispatch(fetchDashboardData(requestParams));
	}, [currentDashboard, currentDashboardDataId, dashboardId, dispatch, initialRequestParams]);
};

export default useFetchInitialDashboardData;
